export default __webpack_public_path__ + "static/fitmee_1-7a358cdb66d0453ce0ed99b99bfb5221.png";